import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScMenu = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
  justify-content: flex-start;
  align-items: center;
  margin-left: 32px;
  overflow-y: auto;
  position: relative;
  gap: 8px;

  @media (${device.desktop}) {
    margin-left: 8px;
  }

  @media (${device.tablet}) {
    flex-direction: column;
    gap: 8px;
    margin: 16px 0 0;
  }

  & > li {
    & > button {
      border: none;
      background: none;
    }

    @media (${device.tablet}) {
      width: 100%;
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 12px;
      padding: 15px 12px 15px 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    & > a,
    & > button {
      display: flex;
      justify-content: center;
      align-items: center;
      color: ${({ theme }) => theme.whiteColor};
      text-decoration: none;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.01em;
      position: relative;
      height: 35px;
      transition: color 0.3s;
      width: 100%;

      @media (${device.desktop}) {
        &.de {
          padding: 0px 4px;
        }
      }

      @media (${device.tablet}) {
        justify-content: flex-start;
        font-size: 16px;
        line-height: 20px;
        padding: 0;
        height: auto;
      }

      svg {
        position: relative;
        margin: 0 8px;
        z-index: -1;
        width: 24px;

        path {
          transition: fill 0.3s;
        }

        @media (${device.tablet}) {
          margin-left: 0;
        }
      }

      @media (hover: hover) {
        &:hover {
          color: ${({ theme }) => theme.mainColor};

          @media (${device.mobile}) {
            color: ${({ theme }) => theme.whiteColor};
          }

          svg path {
            fill: ${({ theme }) => theme.mainColor};
          }
        }
      }
    }

    &.active > a,
    &.active > button {
      color: ${({ theme }) => theme.mainColor};

      svg path {
        stroke: ${({ theme }) => theme.mainColor};

        &:first-child {
          fill: ${({ theme }) => theme.mainColor};
          stroke: transparent;
        }
      }
    }

    .arrow {
      flex-shrink: 0;
      width: 16px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      path {
        stroke: ${({ theme }) => theme.whiteColor};
      }

      & > svg {
        transition: transform 0.2s ease-in-out;
        transform: rotate(90deg) translateX(0) scale(1);
      }
    }
  }
`;

export interface ScStripeProps {
  stripeWidth: number;
  stripeLeft: number;
}

export const ScStripe = styled.div<ScStripeProps>`
  position: absolute;
  left: ${({ stripeLeft }) => `${stripeLeft}px`};
  width: ${({ stripeWidth }) => `${stripeWidth}px`};
  bottom: 0;
  height: 2px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.mainColor};
  transition: 0.6s;
`;
